import { render, staticRenderFns } from "./PausedStreamAction.vue?vue&type=template&id=0a499827&scoped=true"
import script from "./PausedStreamAction.vue?vue&type=script&lang=js"
export * from "./PausedStreamAction.vue?vue&type=script&lang=js"
import style0 from "./PausedStreamAction.vue?vue&type=style&index=0&id=0a499827&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a499827",
  null
  
)

export default component.exports